<template>
  <div>
    <div class="row edit-location-other-info">
      <div class="col-md-6">
        <div v-for="(addPropArg, index) in columnOne(value)">
          <div class="form-group">
            <label for="locationPhotoURL">{{addPropArg.propertyID}}</label>
            <input v-if="!propSpec(addPropArg.propertyID)" class="form-control"  v-model="addPropArg.value"></input>
            <input v-else-if="propSpec(addPropArg.propertyID).type === 'String'" class="form-control"  v-model="addPropArg.value"></input>
            <datepicker v-else-if="propSpec(addPropArg.propertyID).type === 'Date'" v-on:updated="updatedDate($event, propSpec(addPropArg.propertyID).format)" :date_format="propSpec(addPropArg.propertyID).format" :value="genDate(addPropArg.value, propSpec(addPropArg.propertyID).format)" :index="addPropArg.propertyID"></datepicker>
            <input v-else class="form-control"  v-model="addPropArg.value"></input>
          </div>
        </div>
      </div>
      <div class="col-md-6">
          <div v-for="(addPropArg, index) in columnTwo(value)">
            <div class="form-group">
           <label for="locationPhotoURL">{{addPropArg.propertyID}}</label>
            <input v-if="!propSpec(addPropArg.propertyID)" class="form-control"  v-model="addPropArg.value"></input>
            <input v-else-if="propSpec(addPropArg.propertyID).type === 'String'" class="form-control"  v-model="addPropArg.value"></input>
            <datepicker v-else-if="propSpec(addPropArg.propertyID).type === 'Date'" v-on:updated="updatedDate($event, propSpec(addPropArg.propertyID).format)" :date_format="propSpec(addPropArg.propertyID).format" :value="genDate(addPropArg.value, propSpec(addPropArg.propertyID).format)" :index="addPropArg.propertyID" ></datepicker>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>

import _ from 'lodash'
import DatePicker from './gl-datepicker'

export default {
  name: 'AdditionaProps',
  props: {
    value: undefined,
    validProps: undefined,
    excludeProps: undefined
  },
  components: {
    'datepicker': DatePicker
  },
  data: function () {
    return {
      editData: {
        newPropName: '',
        newPropValue: ''
      }
    }
  },
  methods: {
    addNewProperty: function () {
      var newProp = this.makeNewProp(this.editData.newPropName, this.editData.newPropValue)
      this.editData.newPropName = ''
      this.editData.newPropValue = ''
      var newlist = _.cloneDeep(this.value)
      newlist.push(newProp)
      this.emitProp(newlist)
    },
    removeProperty: function (index) {
      var newlist = _.cloneDeep(this.value)
      newlist.splice(index, 1)
      this.emitProp(newlist)
    },
    emitProp: function (newlist) {
      this.$emit('input', newlist)
    },
    makeNewProp: function (name, val) {
      return {
        '@type': 'PropertyValue',
        propertyID: name,
        value: val
      }
    },
    makeDefaultPropList: function () {
      var newList = []
      // console.log('make default pop')
      if (this.validProps) {
        // console.log('valid prop')
        for (var key in this.validProps) {
          newList.push(this.makeNewProp(key, ''))
        }
      } else {
        // console.log('no valid props')
      }
      if (this.hasUnitAddress()) {
        // console.log('adding the unit address prop ' + this.getUnitAddress())
        newList.push(this.makeNewProp('unitAddress', this.value[0].value))
      }
      // console.log(newList)
      if ((this.hasUnitAddress() && newList.length > 1) ||
      (!this.hasUnitAddress() && newList.length > 0)) {
        // console.log(newList)
        this.emitProp(newList)
      }
    },
    getSpecForProp: function (prop) {
      // console.log(this.validProps[prop])
      return this.validProps[prop]
    },
    propSpec: function (prop) {
      // console.log(this.validProps[prop])
      return this.validProps[prop]
    },
    columnOne: function (argProps) {
      let half = 0
      let props = _.clone(argProps)
      // console.log('col one')
      // console.log(argProps)
      _.remove(props, (v) => {
        return v.propertyID === 'unitAddress'
      })
      if (props) {
        half = props.length / 2
      }
      half = Math.ceil(half)
      if (props && half > 0) {
        return props.slice(0, half)
      } else {
        return []
      }
    },
    columnTwo: function (argProps) {
      let half = 0
      let props = _.clone(argProps)
      _.remove(props, (v) => {
        return v.propertyID === 'unitAddress'
      })

      if (props) {
        half = props.length / 2
      }

      half = Math.ceil(half)

      if (half === 0 || half + 1 >= props.length) {
        return []
      } else {
        return props.slice(half, props.length)
      }
    },
    filterProps: function (props) {

    },
    hasUnitAddress: function () {
      return this.value && this.value.length > 0 && this.value[0]['propertyID'] === 'unitAddress'
    },
    getUnitAddress: function () {
      var idx = _.findIndex(this.value, function (o) { return o.propertyID === 'unitAddress' })
      if (idx >= 0) {
        return this.value[idx].value
      } else {
        return false
      }
    },
    updatedDate: function (payload, format) {
      let idx = _.findIndex(this.value, function (o) { return o.propertyID === payload.index })
      if (idx >= 0) {
        this.value[idx].value = this.$moment(payload.date).format(format)
        var newlist = _.cloneDeep(this.value)
        this.emitProp(newlist)
      }
    },
    genDate: function (date, format) {
      let newDate = date
      if (date && date.length > 0) {
        newDate = this.$moment(date, format).toDate()
      }
      return newDate
    }
  },
  created: function () {
    if (!this.value || this.value.length === 0) {
      this.makeDefaultPropList()
    } else {
      // console.log('skip default prop list')
    }
  },
  updated: function () {
    // console.log('updated')
    if (!this.value || this.value.length === 0) {
      this.makeDefaultPropList()
    } else if (this.hasUnitAddress()) {
      this.makeDefaultPropList()
    }
  },
  watch: {
    // value: function (val) {
    // }
  }
}
</script>



// WEBPACK FOOTER //
// additional-props.vue?74eb2908